import * as LucideIcons from 'lucide-react';

const LucideIcon = ({ name, size = 16, color, strokeWidth, className, style }) => {
  const IconComponent = LucideIcons[name];
  if (!IconComponent) return null;
  return <IconComponent size={size} color={color} strokeWidth={strokeWidth} className={className} style={style} />;
};

export default LucideIcon;
